import React from 'react'
import { getClientTimezone, add, startOfHour } from '@chilipiper/date-time'
import * as R from 'remeda'
import { ScheduleHeader } from './components/ScheduleHeader'
import { StyledBookMeetingContainer } from './styles'
import { BookingMeeting } from './BookingMeeting'

const now = new Date()

export const BookingFlowMockBlock = () => {
  const nextWeek = R.range(0, 7).reduce<Record<string, boolean>>((acc, day) => {
    acc[getDateString(add(now, { days: day }))] = true
    return acc
  }, {})

  const slots = R.range(0, 8).map(i => {
    return startOfHour(add(now, { hours: i + 1 })).toISOString()
  })
  return (
    <StyledBookMeetingContainer w='100%' flexDirection='column' borderRadius={8}>
      <ScheduleHeader
        state='scheduling'
        assignee={{ id: '0', name: 'Disabled' }}
        displayName='Disabled'
      />
      <BookingMeeting
        isLoading={false}
        timezone={getClientTimezone()}
        availableDays={nextWeek}
        startTimes={slots}
        durationInMinutes={60}
        cancelRescheduling={R.doNothing}
        onSchedule={R.doNothing}
        onSelectedTimeChange={R.doNothing}
        onTimezoneChange={R.doNothing}
        meetingTypeId='mock'
      />
    </StyledBookMeetingContainer>
  )
}

const getDateString = (date: Date) => {
  return date.toISOString().slice(0, 10)
}
